import { render } from "./ModalThemToaXe.vue?vue&type=template&id=387b0d5c&ts=true"
import script from "./ModalThemToaXe.vue?vue&type=script&lang=ts"
export * from "./ModalThemToaXe.vue?vue&type=script&lang=ts"

import "./ModalThemToaXe.vue?vue&type=style&index=0&id=387b0d5c&lang=scss"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__